import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNewVehicle } from "../../../redux/features/vehicle/vehicleService";
import { showToast } from "../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faRefresh } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { getAllCountries } from "../../../redux/features/countries/countriesService";
import { Link, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import YearsDropdown from "../../../components/YearsDropdown/YearsDropdown";
import { getAllFeatures } from "../../../redux/features/features/featuresService";
import { getAllMakes } from "../../../redux/features/makes/makesService";
import { getModelByMakeId } from "../../../redux/features/models/modelsService";
import { getModelCodesByModelId } from "../../../redux/features/modelCodes/modelCodesService";
import { getAllColors } from "../../../redux/features/colors/colorsService";
import { getAllVehicleTypes } from "../../../redux/features/vehicleTypes/vehicleTypesService";
import { getAllFuels } from "../../../redux/features/fuels/fuelsService";
import { getAllTransmissions } from "../../../redux/features/transmissions/transmissionsService";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 2MB Limit
const Steering = [
    {
        id: 'RHD', name: "RHD"
    },
    {
        id: 'LHD', name: "LHD"
    }
];

const WheelDrive = [
    {
        id: 'WD2', name: "2WD"
    },
    {
        id: 'WD4', name: "4WD"
    }
];

const ExteriorCondition = [
    { id: "ECR", name: "R" },
    { id: "EC3POINT5", name: "3.5" },
    { id: "EC4", name: "4" },
    { id: "EC4POINT5", name: "4.5" },
    { id: "EC5", name: "5" },
    { id: "ECS", name: "S" },
];

const InteriorCondition = [
    { id: "ICA", name: "A" },
    { id: "ICB", name: "B" },
    { id: "ICC", name: "C" },
    { id: "ICD", name: "D" },
];

const RegistrationStatus = [
    {
        id: 'REGISTERED', name: "REGISTERED"
    },
    {
        id: 'UNREGISTERED', name: "UNREGISTERED"
    }
];

const Vehicle = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const imagefilesInputRef = useRef(null);
    const countryDropdownRef = useRef(null);
    const steeringDropdownRef = useRef(null);
    const wheelDriveDropdownRef = useRef(null);
    const interiorDropdownRef = useRef(null);
    const exteriorDropdownRef = useRef(null);
    const featuresDropdownRef = useRef(null);
    const makesDropdownRef = useRef(null);
    const modelsDropdownRef = useRef(null);
    const modelCodesDropdownRef = useRef(null);
    const exColorDropdownRef = useRef(null);
    const inColorDropdownRef = useRef(null);
    const vehicleTypeDropdownRef = useRef(null);
    const fuelTypeDropdownRef = useRef(null);
    const transmissionDropdownRef = useRef(null);
    const registrationDropdownRef = useRef(null);

    const { isVehicleCreating } = useSelector((state) => state.vehicle.newVehicle);
    const { isCountriesLoading, countries } = useSelector((state) => state.country.allCountries);
    const { isFeaturesLoading, features } = useSelector((state) => state.feature.allFeatures);
    const { isMakesLoading, makes } = useSelector((state) => state.make.allMakes);
    const { isModelsByMakeLoading, modelsByMake } = useSelector((state) => state.model.allModelsByMakeId);
    const { isModelCodesByModelLoading, modelCodesByModel } = useSelector((state) => state.modelCode.allModelCodesByModelId);
    const { isColorsLoading, colors } = useSelector((state) => state.color.allColors);
    const { isVehicleTypesLoading, vehicleTypes } = useSelector((state) => state.vehicleType.allVehicleTypes);
    const { isFuelsLoading, fuels } = useSelector((state) => state.fuel.allFuels);
    const { isTransmissionsLoading, transmissions } = useSelector((state) => state.transmission.allTransmissions);

    const [isFirst, setFirst] = useState(true);
    const [isSecond, setSecond] = useState(false);
    const [isThird, setThird] = useState(false);

    const [allVehicleFeatures, setAllVehicleFeatures] = useState([]);
    const [selectedSteering, setSelectedSteering] = useState(null);
    const [selectedWheelDrive, setSelectedWheelDrive] = useState(null);
    const [selectedExCondition, setSelectedExCondition] = useState(null);
    const [selectedInCondition, setSelectedInCondition] = useState(null);
    const [selectedMake, setSelectedMake] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    const [selectedModelCode, setSelectedModelCode] = useState(null);
    const [selectedVehicleType, setSelectedVehicleType] = useState(null);
    const [selectedInColor, setSelectedInColor] = useState(null);
    const [selectedExColor, setSelectedExColor] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedFuelType, setSelectedFuelType] = useState(null);
    const [selectedTransmission, setSelectedTransmission] = useState(null);
    const [selectedRegistrationStatus, setSelectedRegistrationStatus] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        thumbnail: '',
        images: [],
        description: "",
        price: "",
        discountPrice: "",
        chassisNo: "",
        mileage: "",
        engineCapacity: "",
        regYear: "",
        mfgYear: "",
        stockNo: "",
        steering: "",
        wheel_drive: "",
        exterior_condition: "",
        interior_condition: "",
        doorsNo: "",
        seatsNo: "",
        makeId: "",
        modelId: "",
        modelCodeId: "",
        vehicleTypeId: "",
        interiorColorId: "",
        exteriorColorId: "",
        countryId: "",
        fuelId: "",
        transmissionId: "",
        lot_nm: "",
        auction_house: "",
        isPopular: "",
        isFeatured: "",
        commonly_called: "",
        engine_no: "",
        body_color: "",
        grade: "",
        selling_price: "",
        lease_or_loan_amount: "",
        registration_status: ""
    });

    const [draggedIndex, setDraggedIndex] = useState(null);

    const [errorMessages, setErrorMessages] = useState({
        name: '',
        file: '',
        description: "",
        price: "",
        discountPrice: "",
        chassisNo: "",
        mileage: "",
        engineCapacity: "",
        regYear: "",
        mfgYear: "",
        stockNo: "",
        steering: "",
        wheel_drive: "",
        exterior_condition: "",
        interior_condition: "",
        doorsNo: "",
        seatsNo: "",
        makeId: "",
        modelId: "",
        modelCodeId: "",
        vehicleTypeId: "",
        interiorColorId: "",
        exteriorColorId: "",
        countryId: "",
        fuelId: "",
        transmissionId: "",
    });
    const [disabledBtn, setBtnDisable] = useState(false);

    //fetch data
    const fetchCountries = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllCountries(params));
        },
        [dispatch]
    );

    const fetchFeatures = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllFeatures(params));
        },
        [dispatch]
    );

    const fetchMakes = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllMakes(params));
        },
        [dispatch]
    );

    const fetchColors = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllColors(params));
        },
        [dispatch]
    );

    const fetchVehicleTypes = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllVehicleTypes(params));
        },
        [dispatch]
    );

    const fetchFuelTypes = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllFuels(params));
        },
        [dispatch]
    );

    const fetchTransmissions = useCallback(
        (filters = {}) => {
            const params = {
                status: true,
                ...filters,
            };
            dispatch(getAllTransmissions(params));
        },
        [dispatch]
    );

    const fetchModels = async (makeId) => {
        await dispatch(getModelByMakeId({ makeId: makeId })).unwrap()
    };

    const fetchModelCodes = async (modelId) => {
        await dispatch(getModelCodesByModelId({ modelId: modelId })).unwrap()
    };

    useEffect(() => {
        fetchCountries();
        fetchFeatures();
        fetchMakes();
        fetchColors();
        fetchVehicleTypes();
        fetchFuelTypes();
        fetchTransmissions();
    }, [fetchCountries, fetchFeatures, fetchMakes, fetchColors, fetchVehicleTypes, fetchFuelTypes, fetchTransmissions]);

    const handleSelect = (option) => {
        setFormData({ ...formData, countryId: option.id });
        setErrorMessages({ ...errorMessages, countryId: "" });
        setSelectedCountry({
            id: option.id,
            name: option.name
        });
    };

    const handleSteeringSelect = (option) => {
        setFormData({ ...formData, steering: option.id });
        setErrorMessages({ ...errorMessages, steering: "" });
        setSelectedSteering({
            id: option.id,
            name: option.name
        });
    };

    const handleWheelDriveSelect = (option) => {
        setFormData({ ...formData, wheel_drive: option.name });
        setErrorMessages({ ...errorMessages, wheel_drive: "" });
        setSelectedWheelDrive({
            id: option.id,
            name: option.name
        });
    };

    const handleInteriorSelect = (option) => {
        setFormData({ ...formData, interior_condition: option.name });
        setErrorMessages({ ...errorMessages, interior_condition: "" });
        setSelectedInCondition({
            id: option.id,
            name: option.name
        });
    };

    const handleExteriorSelect = (option) => {
        setFormData({ ...formData, exterior_condition: option.name });
        setErrorMessages({ ...errorMessages, exterior_condition: "" });
        setSelectedExCondition({
            id: option.id,
            name: option.name
        });
    };

    const handleRemoveFeature = (featureIndex) => {
        const updatedFeatures = [...allVehicleFeatures];
        updatedFeatures.splice(featureIndex, 1);
        setAllVehicleFeatures(updatedFeatures);
    };

    const handleFeatureSelect = (feature) => {
        setErrorMessages({ ...errorMessages, features: "" });
        const isDuplicate = allVehicleFeatures.some(
            (existingFeature) => existingFeature.id === feature.id
        );

        if (!isDuplicate) {
            setAllVehicleFeatures([...allVehicleFeatures, feature]);
        }
    };

    const handleMakeSelect = (option) => {
        setFormData({ ...formData, makeId: option.id });
        setErrorMessages({ ...errorMessages, makeId: "" });
        setSelectedModel(null);
        setSelectedModelCode(null);
        fetchModels(option.id);
        setSelectedMake({
            id: option.id,
            name: option.name
        });
    };

    const handleModelSelect = (option) => {
        setFormData({ ...formData, modelId: option.id });
        setErrorMessages({ ...errorMessages, modelId: "" });
        setSelectedModelCode(null);
        fetchModelCodes(option.id);
        setSelectedModel({
            id: option.id,
            name: option.name
        });
    };

    const handleModelCodeSelect = (option) => {
        setFormData({ ...formData, modelCodeId: option.id });
        setErrorMessages({ ...errorMessages, modelCodeId: "" });
        setSelectedModelCode({
            id: option.id,
            name: option.name
        });
    };

    const handleExColorSelect = (option) => {
        setFormData({ ...formData, exteriorColorId: option.id });
        setErrorMessages({ ...errorMessages, exteriorColorId: "" });
        setSelectedExColor({
            id: option.id,
            name: option.name
        });
    };

    const handleInColorSelect = (option) => {
        setFormData({ ...formData, interiorColorId: option.id });
        setErrorMessages({ ...errorMessages, interiorColorId: "" });
        setSelectedInColor({
            id: option.id,
            name: option.name
        });
    };

    const handleVehicleTypeSelect = (option) => {
        setFormData({ ...formData, vehicleTypeId: option.id });
        setErrorMessages({ ...errorMessages, vehicleTypeId: "" });
        setSelectedVehicleType({
            id: option.id,
            name: option.name
        });
    };

    const handleFuelSelect = (option) => {
        setFormData({ ...formData, fuelId: option.id });
        setErrorMessages({ ...errorMessages, fuelId: "" });
        setSelectedFuelType({
            id: option.id,
            name: option.name
        });
    };

    const handleTransmissionSelect = (option) => {
        setFormData({ ...formData, transmissionId: option.id });
        setErrorMessages({ ...errorMessages, transmissionId: "" });
        setSelectedTransmission({
            id: option.id,
            name: option.name
        });
    };

    const handleRegistrationStatus = (option) => {
        setFormData({ ...formData, registration_status: option.id });
        setSelectedRegistrationStatus({
            id: option.id,
            name: option.name
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleRegYearChange = (selectedMonth) => {
        setFormData((prev) => ({ ...prev, regYear: selectedMonth.name }));
        setErrorMessages({ ...errorMessages, regYear: '' });
    };

    const handleMfgYearChange = (selectedMonth) => {
        setFormData((prev) => ({ ...prev, mfgYear: selectedMonth.name }));
        setErrorMessages({ ...errorMessages, mfgYear: '' });
    };

    const validateFile = (thumbnail) => {
        if (thumbnail) {
            if (!thumbnail.type.startsWith("image/")) {
                setErrorMessages({ ...errorMessages, file: "Only image files are allowed." });
                return;
            }

            // if (thumbnail.size > MAX_FILE_SIZE) {
            //     setErrorMessages({ ...errorMessages, file: "File size exceeds 2MB limit." });
            //     return;
            // }

            setErrorMessages({ ...errorMessages, file: "" });
            setFormData({ ...formData, thumbnail });
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const selectedFile = event.dataTransfer.files[0];

        if (selectedFile) {
            validateFile(selectedFile);
        }
    };

    const handleFileChange = (event) => {
        if (event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            validateFile(selectedFile);
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    //Handle Multiple images
    const handleMultipleFileChange = (event) => {
        const newFiles = Array.from(event.target.files).map((file, index) => ({
            id: Date.now() + index, // Unique ID (timestamp-based)
            file,
            order: formData.images?.length + index, // Assign order
        }));

        setFormData((prev) => ({
            ...prev,
            images: [...prev.images, ...newFiles], // Append new images
        }));
    };

    const handleDropFirstImages = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const droppedFiles = Array.from(event.dataTransfer.files).map((file, index) => ({
            id: Date.now() + index, // Unique ID
            file,
            order: formData.images.length + index, // Assign order
        }));

        if (droppedFiles.length > 0) {
            setFormData((prev) => ({
                ...prev,
                images: [...prev.images, ...droppedFiles], // Append dropped images
            }));
        }
    };

    // Handle removing an image
    const handleRemoveImage = (id) => {
        setFormData((prev) => ({
            ...prev,
            images: prev.images.filter((image) => image.id !== id),
        }));
    };

    // Handle drag start
    const [dragOverIndex, setDragOverIndex] = useState(null); // Track index being hovered
    const [isDragging, setIsDragging] = useState(false); // Track if dragging is happening

    // Handle drag start
    const handleDragStart = (index) => {
        setDraggedIndex(index);
        setIsDragging(true); // Set dragging state
    };

    // Handle drag over (prevent default and highlight drop area)
    const handleDragOver = (event, index) => {
        event.preventDefault();
        setDragOverIndex(index); // Set hovered index
    };

    // Handle drag leave (remove highlight when leaving drop area)
    const handleDragLeave = () => {
        setDragOverIndex(null);
    };

    // Handle drop (reorder images)
    const handleDropImages = (index) => {
        if (draggedIndex === null) return;

        const updatedImages = [...formData.images];
        const [movedImage] = updatedImages.splice(draggedIndex, 1);
        updatedImages.splice(index, 0, movedImage);

        // Update order after rearrangement
        const reorderedImages = updatedImages.map((img, i) => ({ ...img, order: i }));

        setFormData((prev) => ({
            ...prev,
            images: reorderedImages,
        }));

        // Reset drag states
        setDraggedIndex(null);
        setDragOverIndex(null);
        setIsDragging(false);
    };

    // Handle click to open file input
    const handleClickImages = () => {
        imagefilesInputRef.current.click();
    };

    // Validate input
    const isValidVehicleFirst = () => {
        const errors = {};
        if (!formData.name.trim()) {
            errors.name = "Name is required.";
        }
        if (!formData.chassisNo) {
            errors.chassisNo = "Chassis Number is required.";
        }
         if (!formData.description) {
            errors.description = "Description is required.";
        }
        // if (!formData.description) {
        //     errors.description = "Description is required.";
        // }
        if (!formData.mileage) {
            errors.mileage = "Mileage is required.";
        }
        if (!formData.engineCapacity) {
            errors.engineCapacity = "Engine Capacity is required.";
        }
        if (!formData.regYear) {
            errors.regYear = "Registration Year is required.";
        }
        if (!formData.mfgYear) {
            errors.mfgYear = "Manufacturing Year is required.";
        }
        if (!selectedCountry) {
            errors.country = "Country is required.";
        }
        if (!selectedSteering) {
            errors.steering = "Steering is required.";
        }
        if (!selectedWheelDrive) {
            errors.wheel_drive = "Wheel Drive is required.";
        }
        if (!selectedExCondition) {
            errors.exterior_condition = "Exterior Condition is required.";
        }
        if (!selectedInCondition) {
            errors.interior_condition = "Interior Condition is required.";
        }
        if (!formData.doorsNo || formData.doorsNo <= 0) errors.doorsNo = "Number of doors is required and must be greater than zero.";
        if (!formData.seatsNo || formData.seatsNo <= 0) errors.seatsNo = "Number of seats is required and must be greater than zero.";
        if (!formData.makeId) errors.makeId = "Vehicle make is required.";
        if (!formData.modelId) errors.modelId = "Model is required.";
        // if (!formData.modelCodeId) errors.modelCodeId = "Model code is required.";
        if (!formData.exteriorColorId) errors.exteriorColorId = "Exterior color is required.";
        if (!formData.interiorColorId) errors.interiorColorId = "Interior color is required.";
        if (!formData.vehicleTypeId) errors.vehicleTypeId = "Vehicle type is required.";
        if (!formData.fuelId) errors.fuelId = "Fuel type is required.";
        if (!formData.transmissionId) errors.transmissionId = "Transmission type is required.";

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    // Validate input
    const isValidVehicle = () => {
        const errors = {};
        const trimmedName = formData.name.trim();

        if (!trimmedName) {
            errors.name = "Name is required.";
        }
        if (!formData.thumbnail) {
            errors.thumbnail = "Image is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const resetAllSelections = () => {
        setSelectedWheelDrive(null);
        setSelectedExCondition(null);
        setSelectedInCondition(null);
        setSelectedMake(null);
        setSelectedModel(null);
        setSelectedModelCode(null);
        setSelectedVehicleType(null);
        setSelectedInColor(null);
        setSelectedExColor(null);
        setSelectedCountry(null);
        setSelectedFuelType(null);
        setSelectedTransmission(null);
    };

    const insertNewVehicle = async () => {
        // if (isValidVehicle(formData)) {
        setBtnDisable(true);
        formData.vehicle_features = allVehicleFeatures;
        try {
            const response = await dispatch(addNewVehicle(formData)).unwrap();
            setBtnDisable(false);
            setFormData({
                name: '',
                file: '',
                images: [null]
            });
            setThird(false);
            setSecond(false);
            setFirst(true);
            setAllVehicleFeatures([]);
            if (countryDropdownRef.current) countryDropdownRef.current.clearSelection();
            if (steeringDropdownRef.current) steeringDropdownRef.current.clearSelection();
            if (wheelDriveDropdownRef.current) wheelDriveDropdownRef.current.clearSelection();
            if (interiorDropdownRef.current) interiorDropdownRef.current.clearSelection();
            if (exteriorDropdownRef.current) exteriorDropdownRef.current.clearSelection();
            if (featuresDropdownRef.current) featuresDropdownRef.current.clearSelection();
            if (makesDropdownRef.current) makesDropdownRef.current.clearSelection();
            if (modelsDropdownRef.current) modelsDropdownRef.current.clearSelection();
            if (modelCodesDropdownRef.current) modelCodesDropdownRef.current.clearSelection();
            if (exColorDropdownRef.current) exColorDropdownRef.current.clearSelection();
            if (inColorDropdownRef.current) inColorDropdownRef.current.clearSelection();
            if (vehicleTypeDropdownRef.current) vehicleTypeDropdownRef.current.clearSelection();
            if (fuelTypeDropdownRef.current) fuelTypeDropdownRef.current.clearSelection();
            if (transmissionDropdownRef.current) transmissionDropdownRef.current.clearSelection();
            if (registrationDropdownRef.current) registrationDropdownRef.current.clearSelection();
            resetAllSelections();
            navigate('/admin/vehicles')
            showToast('success', response.message);
        }
        catch (error) {
            setBtnDisable(false);
            showToast('error', error.message);
        };
        // }
    };

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add New Vehicle</h1>
                <div className={styles.formContainer}>
                    <form
                        className={styles.coordinatorForm}
                        noValidate
                    >
                        {isFirst &&
                            <div className={styles.vehicleFormGroup}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Name<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='name'
                                                name='name'
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                placeholder='Enter Vehicle Name'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.name && (
                                                <p className={`text-danger`}>{errorMessages.name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Chassis Number
                                            </label>
                                            <input
                                                type='text'
                                                id='chassisNo'
                                                name='chassisNo'
                                                value={formData.chassisNo}
                                                onChange={handleInputChange}
                                                placeholder='Enter Chassis Number'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.chassisNo && (
                                                <p className={`text-danger`}>{errorMessages.chassisNo}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Lot NM
                                            </label>
                                            <input
                                                type='text'
                                                id='lot_nm'
                                                name='lot_nm'
                                                value={formData.lot_nm}
                                                onChange={handleInputChange}
                                                placeholder='Enter Lot NM'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.lot_nm && (
                                                <p className={`text-danger`}>{errorMessages.lot_nm}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Auction House
                                            </label>
                                            <input
                                                type='text'
                                                id='auction_house'
                                                name='auction_house'
                                                value={formData.auction_house}
                                                onChange={handleInputChange}
                                                placeholder='Enter Auction House'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.auction_house && (
                                                <p className={`text-danger`}>{errorMessages.auction_house}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Description
                                        </label>
                                        <input
                                            type='textarea'
                                            id='description'
                                            name='description'
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            placeholder='Enter the description'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.description && (
                                            <p className={`text-danger`}>{errorMessages.description}</p>
                                        )}
                                    </div>
                                </div>
                                {/* <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Price (Yen)
                                            </label>
                                            <input
                                                type='number'
                                                id='price'
                                                name='price'
                                                value={formData.price}
                                                onChange={handleInputChange}
                                                placeholder='Enter Vehicle Price'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.price && (
                                                <p className={`text-danger`}>{errorMessages.price}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Discount Price (Yen)
                                            </label>
                                            <input
                                                type='number'
                                                id='discountPrice'
                                                name='discountPrice'
                                                value={formData.discountPrice}
                                                onChange={handleInputChange}
                                                placeholder='Enter Discount Price'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.discountPrice && (
                                                <p className={`text-danger`}>{errorMessages.discountPrice}</p>
                                            )}
                                        </div>
                                    </div>
                                </div> */}
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Mileage (km)
                                            </label>
                                            <input
                                                type='number'
                                                id='mileage'
                                                name='mileage'
                                                value={formData.mileage}
                                                onChange={handleInputChange}
                                                placeholder='Enter Mileage'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.mileage && (
                                                <p className={`text-danger`}>{errorMessages.mileage}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Engine No
                                            </label>
                                            <input
                                                type='text'
                                                id='engine_no'
                                                name='engine_no'
                                                value={formData.engine_no}
                                                onChange={handleInputChange}
                                                placeholder='Enter Engine No'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Engine Capacity (cc)
                                            </label>
                                            <input
                                                type='number'
                                                id='engineCapacity'
                                                name='engineCapacity'
                                                value={formData.engineCapacity}
                                                onChange={handleInputChange}
                                                placeholder='Enter Engine Capacity'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.engineCapacity && (
                                                <p className={`text-danger`}>{errorMessages.engineCapacity}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col sm-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Reg. Year
                                            </label>
                                            <YearsDropdown onChange={handleRegYearChange} value={formData.regYear} />
                                            {errorMessages.regYear && (
                                                <p className={`text-danger`}>{errorMessages.regYear}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col sm-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Mfg. Year
                                            </label>
                                            <YearsDropdown onChange={handleMfgYearChange} value={formData.mfgYear} />
                                            {errorMessages.mfgYear && (
                                                <p className={`text-danger`}>{errorMessages.mfgYear}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Country
                                                <Link to="/admin/options/countries" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isCountriesLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchCountries} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={countryDropdownRef}
                                                options={countries}
                                                placeholder="Choose an Option"
                                                onSelect={handleSelect}
                                                value={selectedCountry?.name}
                                            />
                                            {errorMessages.stockNo && (
                                                <p className={`text-danger`}>{errorMessages.stockNo}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Steering<span className={`required-star`}>*</span>
                                            </label>
                                            <Dropdown
                                                ref={steeringDropdownRef}
                                                options={Steering}
                                                placeholder="Choose an Option"
                                                onSelect={handleSteeringSelect}
                                                value={selectedSteering?.name}
                                            />
                                            {errorMessages.steering && (
                                                <p className={`text-danger`}>{errorMessages.steering}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Wheel Drive <span className={`required-star`}>*</span>
                                            </label>
                                            <Dropdown
                                                ref={wheelDriveDropdownRef}
                                                options={WheelDrive}
                                                placeholder="Choose an Option"
                                                onSelect={handleWheelDriveSelect}
                                                value={selectedWheelDrive?.name}
                                            />
                                            {errorMessages.wheel_drive && (
                                                <p className={`text-danger`}>{errorMessages.wheel_drive}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Exterior Condition<span className={`required-star`}>*</span>
                                            </label>
                                            <Dropdown
                                                ref={exteriorDropdownRef}
                                                options={ExteriorCondition}
                                                placeholder="Choose an Option"
                                                onSelect={handleExteriorSelect}
                                                value={selectedExCondition?.name}
                                            />
                                            {errorMessages.exterior_condition && (
                                                <p className={`text-danger`}>{errorMessages.exterior_condition}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Interior Condition <span className={`required-star`}>*</span>
                                            </label>
                                            <Dropdown
                                                ref={interiorDropdownRef}
                                                options={InteriorCondition}
                                                placeholder="Choose an Option"
                                                onSelect={handleInteriorSelect}
                                                value={selectedInCondition?.name}
                                            />
                                            {errorMessages.interior_condition && (
                                                <p className={`text-danger`}>{errorMessages.interior_condition}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                No of Doors<span className={`required-star`}>*</span>
                                            </label>
                                            <input
                                                type='number'
                                                id='doorsNo'
                                                name='doorsNo'
                                                value={formData.doorsNo}
                                                onChange={handleInputChange}
                                                placeholder='Number of Doors'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.doorsNo && (
                                                <p className={`text-danger`}>{errorMessages.doorsNo}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                No of Seats
                                            </label>
                                            <input
                                                type='number'
                                                id='seatsNo'
                                                name='seatsNo'
                                                value={formData.seatsNo}
                                                onChange={handleInputChange}
                                                placeholder='Number of Seats'
                                                className={`form-input-default`}
                                            />
                                            {errorMessages.seatsNo && (
                                                <p className={`text-danger`}>{errorMessages.seatsNo}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Features
                                            <Link to="/admin/options/features" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                            {isFeaturesLoading ?
                                                <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchFeatures} style={{ cursor: "pointer" }} />
                                            }
                                        </label>
                                        <div className={styles.featuresCard}>
                                            {allVehicleFeatures ?
                                                allVehicleFeatures.map((feature, index) => (
                                                    <button
                                                        type="button"
                                                        key={index}
                                                        className={styles.featureCard}
                                                        onClick={() => handleRemoveFeature(index)}
                                                    >
                                                        {feature.name}
                                                        {index < allVehicleFeatures.length && " X"}
                                                    </button>
                                                ))
                                                : ""}{" "}
                                        </div>
                                        <Dropdown
                                            ref={featuresDropdownRef}
                                            options={features}
                                            placeholder="Choose an Option"
                                            onSelect={handleFeatureSelect}
                                        />
                                        {errorMessages.stockNo && (
                                            <p className={`text-danger`}>{errorMessages.stockNo}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Make
                                                <Link to="/admin/options/makes" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isMakesLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchMakes} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={makesDropdownRef}
                                                options={makes}
                                                placeholder="Choose an Option"
                                                onSelect={handleMakeSelect}
                                                value={selectedMake?.name}
                                            />
                                            {errorMessages.makeId && (
                                                <p className={`text-danger`}>{errorMessages.makeId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col sm-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Model
                                                <Link to="/admin/options/models" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {selectedMake && selectedMake.id !== null && isModelsByMakeLoading ? (
                                                    <ClipLoader size={15} />
                                                ) : (
                                                    <FontAwesomeIcon
                                                        icon={faRefresh}
                                                        onClick={() => selectedMake && fetchModels(selectedMake.id)}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                )}
                                            </label>
                                            <Dropdown
                                                ref={modelsDropdownRef}
                                                options={modelsByMake}
                                                placeholder="Choose an Option"
                                                onSelect={handleModelSelect}
                                                value={selectedModel?.name}
                                            />
                                            {errorMessages.modelId && (
                                                <p className={`text-danger`}>{errorMessages.modelId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col sm-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Model Codes
                                                <Link to="/admin/options/model-codes" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {selectedModel && selectedModel.id !== null && isModelCodesByModelLoading ? (
                                                    <ClipLoader size={15} />
                                                ) : (
                                                    <FontAwesomeIcon
                                                        icon={faRefresh}
                                                        onClick={() => selectedModel && fetchModelCodes(selectedModel.id)}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                )}
                                            </label>
                                            <Dropdown
                                                ref={modelCodesDropdownRef}
                                                options={modelCodesByModel}
                                                placeholder="Choose an Option"
                                                onSelect={handleModelCodeSelect}
                                                value={selectedModelCode?.name}
                                            />
                                            {errorMessages.modelCodeId && (
                                                <p className={`text-danger`}>{errorMessages.modelCodeId}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Exterior Color
                                                <Link to="/admin/options/colors" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isColorsLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchColors} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={exColorDropdownRef}
                                                options={colors}
                                                placeholder="Choose an Option"
                                                onSelect={handleExColorSelect}
                                                value={selectedExColor?.name}
                                            />
                                            {errorMessages.exteriorColorId && (
                                                <p className={`text-danger`}>{errorMessages.exteriorColorId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Interior Color
                                                <Link to="/admin/options/colors" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isColorsLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchColors} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={inColorDropdownRef}
                                                options={colors}
                                                placeholder="Choose an Option"
                                                onSelect={handleInColorSelect}
                                                value={selectedInColor?.name}
                                            />
                                            {errorMessages.interiorColorId && (
                                                <p className={`text-danger`}>{errorMessages.interiorColorId}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Vehicle Type
                                                <Link to="/admin/options/vehicle-types" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isVehicleTypesLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchVehicleTypes} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={vehicleTypeDropdownRef}
                                                options={vehicleTypes}
                                                placeholder="Choose an Option"
                                                onSelect={handleVehicleTypeSelect}
                                                value={selectedVehicleType?.name}
                                            />
                                            {errorMessages.vehicleTypeId && (
                                                <p className={`text-danger`}>{errorMessages.vehicleTypeId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Fuel Type
                                                <Link to="/admin/options/fuels" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isFuelsLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchFuelTypes} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={fuelTypeDropdownRef}
                                                options={fuels}
                                                placeholder="Choose an Option"
                                                onSelect={handleFuelSelect}
                                                value={selectedFuelType?.name}
                                            />
                                            {errorMessages.fuelId && (
                                                <p className={`text-danger`}>{errorMessages.fuelId}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Transmission
                                                <Link to="/admin/options/transmissions" target="_blank" style={{ cursor: "pointer", color: "black", marginLeft: "5px", marginRight: "5px" }}><FontAwesomeIcon icon={faPlusCircle} /></Link>
                                                {isTransmissionsLoading ?
                                                    <ClipLoader size={15} /> : <FontAwesomeIcon icon={faRefresh} onClick={fetchTransmissions} style={{ cursor: "pointer" }} />
                                                }
                                            </label>
                                            <Dropdown
                                                ref={transmissionDropdownRef}
                                                options={transmissions}
                                                placeholder="Choose an Option"
                                                onSelect={handleTransmissionSelect}
                                                value={selectedTransmission?.name}
                                            />
                                            {errorMessages.transmissionId && (
                                                <p className={`text-danger`}>{errorMessages.transmissionId}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Commonly Called
                                            </label>
                                            <input
                                                type='text'
                                                id='commonly_called'
                                                name='commonly_called'
                                                value={formData.commonly_called}
                                                onChange={handleInputChange}
                                                placeholder='Enter Commonly Called'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Body Color
                                            </label>
                                            <input
                                                type='text'
                                                id='body_color'
                                                name='body_color'
                                                value={formData.body_color}
                                                onChange={handleInputChange}
                                                placeholder='Enter Body Color'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Grade
                                            </label>
                                            <input
                                                type='text'
                                                id='grade'
                                                name='grade'
                                                value={formData.grade}
                                                onChange={handleInputChange}
                                                placeholder='Enter Grade'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Registration Status
                                            </label>
                                            <Dropdown
                                                ref={registrationDropdownRef}
                                                options={RegistrationStatus}
                                                placeholder="Choose an Option"
                                                onSelect={handleRegistrationStatus}
                                                value={selectedRegistrationStatus?.name}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Selling Price
                                            </label>
                                            <input
                                                type='text'
                                                id='selling_price'
                                                name='selling_price'
                                                value={formData.selling_price}
                                                onChange={handleInputChange}
                                                placeholder='Enter Selling Price'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Lease or Loan Amount
                                            </label>
                                            <input
                                                type='text'
                                                id='lease_or_loan_amount'
                                                name='lease_or_loan_amount'
                                                value={formData.lease_or_loan_amount}
                                                onChange={handleInputChange}
                                                placeholder='Enter Lease or Loan Amount'
                                                className={`form-input-default`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Featured
                                            </label>
                                            <div className={styles.radioValue}>
                                                <label htmlFor='isFeatured' className={`form-label`}>
                                                    <input type="radio" name="isFeatured" value="true" checked={formData?.isFeatured === 'true'} onChange={handleInputChange} className={styles.customRadio} />
                                                </label>
                                                Yes
                                                <label htmlFor='isFeatured' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                    <input type="radio" name="isFeatured" value="false" checked={formData?.isFeatured === 'false'} onChange={handleInputChange} className={styles.customRadio} />
                                                </label>
                                                No
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`form-input-col md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Popular
                                            </label>
                                            <div className={styles.radioValue}>
                                                <label htmlFor='isPopular' className={`form-label`}>
                                                    <input type="radio" name="isPopular" value="true" onChange={handleInputChange} className={styles.customRadio} />
                                                </label>
                                                Yes
                                                <label htmlFor='isPopular' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                    <input type="radio" name="isPopular" value="false" onChange={handleInputChange} className={styles.customRadio} />
                                                </label>
                                                No
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.btnSec}>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        onClick={() => {
                                            if (isValidVehicleFirst()) {
                                                setFirst(false);
                                                setSecond(true);
                                                setThird(false);
                                            }
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        }
                        {isSecond &&
                            <div className={styles.vehicleFormGroup}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Thumbnail Image<span className={`required-star`}>*</span>
                                            </label>
                                            <div
                                                onDrop={handleDrop}
                                                onDragOver={(event) => event.preventDefault()}
                                                onClick={handleClick}
                                                className={`drop-input`}
                                            >
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    accept="image/*"
                                                    onChange={handleFileChange}
                                                    style={{ display: "none" }}
                                                />
                                                {(!formData.thumbnail) ? <p>Drag & Drop a file here or click to select</p>
                                                    :
                                                    <div className={`inserted-file`}>
                                                        <div className={`file-card`}>
                                                            <img src={URL.createObjectURL(formData.thumbnail)} alt='File Type' className={`${styles.thumbnailImg} left-icon`} />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {errorMessages.file && (
                                                <p className={`text-danger`}>{errorMessages.file}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.btnSec}>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        onClick={() => {
                                            setFirst(true);
                                            setSecond(false);
                                            setThird(false);
                                        }}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        onClick={() => {
                                            setFirst(false);
                                            setSecond(false);
                                            setThird(true);
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        }
                        {isThird &&
                            <div className={styles.vehicleFormGroup}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Images<span className={`required-star`}>*</span>
                                        </label>
                                        <div
                                            onDrop={handleDropFirstImages}
                                            onDragOver={(event) => event.preventDefault()}
                                            // onClick={handleClickImages}
                                            className={`drop-input-full`}
                                        >
                                            <input
                                                type="file"
                                                ref={imagefilesInputRef}
                                                accept="image/*"
                                                multiple
                                                onChange={handleMultipleFileChange}
                                                style={{ display: "none" }}
                                            />
                                            {<div className={styles.imagePreviewContainer}>
                                                {formData.images.length > 0 && formData.images?.map((image, index) => (
                                                    <div
                                                        key={image.id}
                                                        className={`${styles.image_preview} ${isDragging && draggedIndex === index ? `${styles.dragging}` : ''} ${dragOverIndex === index ? `${styles.drag_over}` : ''}`}
                                                        draggable
                                                        onDragStart={() => handleDragStart(index)}
                                                        onDragOver={(event) => handleDragOver(event, index)}
                                                        onDragLeave={handleDragLeave}
                                                        onDrop={() => handleDropImages(index)}
                                                    >
                                                        <img src={URL.createObjectURL(image.file)} alt="Uploaded" className="preview-image" />
                                                        <button className={styles.remove_btn} onClick={() => handleRemoveImage(image.id)}>×</button>
                                                    </div>
                                                ))}
                                                <div className={styles.vehicleAddCard} onClick={handleClickImages} >
                                                    <FontAwesomeIcon icon={faPlusCircle} size="2xl" className={styles.plusIcon} />
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        {errorMessages.file && (
                                            <p className={`text-danger`}>{errorMessages.file}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.btnSec}>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        onClick={() => {
                                            setFirst(false);
                                            setSecond(true);
                                            setThird(false);
                                        }}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledBtn}
                                        onClick={insertNewVehicle}
                                    >
                                        {isVehicleCreating ? <BeatLoader color='#ffffff' /> : `Create`}
                                    </button>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Vehicle;
